import React,{useState} from 'react'
import {Context as AuthContext} from '../Context/AuthContext'
import { useContext } from 'react'
import { Redirect } from 'react-router'

const Reguser = () => {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [password_confrim, setPassword_confirm] = useState('')
    const [name, setName] = useState('')
    const token = localStorage.getItem('token')
    const {state, reg} = useContext(AuthContext)
    
    let redirect = null;

    console.log(token)
    if(token){
        redirect = <Redirect to='/dashboard' />
    }
    if(state.token){
        redirect = <Redirect to='/dashboard' />
    }
    const sumbit = async(e) => {
        e.preventDefault()
        if(password !== password_confrim){
            return alert('Password do not match')
        }

        reg({name, email, password, password_confrim})
    }
    // console.log(state)

    return (
        <div>
            {redirect}
            <div className='Login' >
                <form onSubmit={sumbit} >
                    <input type="text" placeholder='Name' className='email' required value={name} onChange={e => setName(e.target.value)} />
                    <input value={email} onChange={(e) => setEmail(e.target.value)} className='email' type="email" placeholder='Email address' required />
                    <input value={password} onChange={(e) => setPassword(e.target.value)} className='password' type="password" placeholder='Password' required />
                    <input value={password_confrim} onChange={(e) => setPassword_confirm(e.target.value)} className='password' type="password" placeholder='Repeat Password' required />
                    <button className='button' >Register</button>
                </form>
            </div>
        </div>
    )
}

export default Reguser
